// extracted by mini-css-extract-plugin
export default {"image":"AlphaPage_image__37ftj","bgBlur":"AlphaPage_bgBlur__KK090","bgAlpha":"AlphaPage_bgAlpha__DBopU"};